<template>
  <modal ref="modalEliminar" titulo="Treure projecte" icono="fa-solid fa-circle-minus" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${item.id}`" :loading="loading.proyectosGestion[index]" @abrir="abrirModal(`autofocusEliminacion${item.id}`)">
    <template v-slot:body>
      <div class="text-left">
        Vols treure de <i>{{ tituloSeguimiento }}</i> el projecte <b>{{ item.titol }}</b>?
      </div>
    </template>
    <template v-slot:footer>
      <button :ref="`autofocusEliminacion${item.id}`" type="submit" class="btn btn-danger" :disabled="loading.proyectosGestion[index]" @click="retirarKPI(item.id, index)">
        <i-submit icono="fa-circle-minus" :loading="loading.proyectosGestion[index]" />Confirmar
      </button>
    </template>
  </modal>
</template>

<script>
export default {
  name: "ModalEliminarProyecto",
  props: ["item", "index", "tituloSeguimiento", "loading", "trabajador"],
  methods: {
    abrirModal(autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    retirarKPI(id_projecte, index) {
      this.$set(this.loading.proyectosGestion, index, true);

      this.$http
        .put("api/kpis", { id_projecte, es_visible: false, id_treballador: this.trabajador })
        .then((response) => {
          if (![200, 201, 409].includes(response.status)) return;

          this.$emit("retirarProyecto", id_projecte, index);
        })
        .finally(() => this.$set(this.loading.proyectosGestion, index, false));
    },
    cerrar() {
      this.$refs.modalEliminar.cerrar();
    },
  },
}
</script>